'use client';

import { useState } from 'react';

import {
    Button,
    ButtonList,
    ButtonVariant,
    ModalBody,
    ModalFooter,
    RadioTile,
    RadioTiles,
    Spacer,
    SpacerSize,
    Text,
    TypographyAlign,
} from '@bytel/trilogy-react';

import { PLAY } from '@constants/provider';

import { FaiUpsellModalProps } from './fai-upsell-modal.props';

export function DowngradeMustPlayUpsellModal({ clickedOffer, upsellOffer, onAddOffer }: Readonly<FaiUpsellModalProps>) {
    const [choice, setChoice] = useState<PLAY>(PLAY._3P);

    return (
        <>
            <ModalBody>
                <Text typo={TypographyAlign.TEXT_LEFT}>Profitez de + de 180 chaînes avec votre Bbox must&nbsp;🍿</Text>
                <Spacer size={SpacerSize.SIX} />
                <RadioTiles>
                    <RadioTile
                        name='checkbox1'
                        id='choiceYes'
                        label='Avec un décodeur TV'
                        description='Sur votre TV principale.'
                        value={PLAY._3P}
                        checked={choice === PLAY._3P}
                        onChange={() => setChoice(PLAY._3P)}
                        horizontal
                    />
                    <RadioTile
                        name='checkbox1'
                        id='choiceNo'
                        label='Avec l’application b.tv'
                        description='Sur votre TV connectée, smartphone, tablette, PC.'
                        value={PLAY._2P}
                        checked={choice === PLAY._2P}
                        onChange={() => setChoice(PLAY._2P)}
                        horizontal
                    />
                </RadioTiles>
            </ModalBody>
            <ModalFooter>
                <ButtonList>
                    <Button
                        variant={ButtonVariant.CONVERSION}
                        onClick={() => onAddOffer?.(choice === PLAY._3P ? clickedOffer : upsellOffer)}
                    >
                        Continuer
                    </Button>
                </ButtonList>
            </ModalFooter>
        </>
    );
}
